import { Eye, Lock } from 'lucide-react';

/**
 * Banner + full-page lock helpers for permission enforcement.
 *
 * Usage:
 *   const { canEdit, canView, isReadOnly } = usePermissions(permissions);
 *   if (!canView('players')) return <NoAccessScreen area="Players" />;
 *   {isReadOnly('players') && <ReadOnlyBanner area="Players" />}
 */

export function ReadOnlyBanner({ area }) {
  return (
    <div
      className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900"
      data-testid="read-only-banner"
    >
      <Eye className="h-4 w-4" />
      <span>
        <span className="font-semibold">View-only mode.</span> You can browse{' '}
        {area ? area.toLowerCase() : 'this section'} but can't make changes. Ask your
        head coach to update your permissions.
      </span>
    </div>
  );
}

export function NoAccessScreen({ area }) {
  return (
    <div
      className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center"
      data-testid="no-access-screen"
    >
      <Lock className="h-10 w-10 text-muted-foreground" />
      <h2 className="font-heading text-2xl uppercase tracking-tight">
        {area || 'This section'} is locked
      </h2>
      <p className="max-w-md text-sm text-muted-foreground">
        Your head coach hasn't given you access to this area yet. Reach out to them
        if you think this is a mistake.
      </p>
    </div>
  );
}
